export default __webpack_public_path__ + "static/media/CampingTools.a428cf1a.jpg";